import { render, staticRenderFns } from "./StudentOverviewMarkTab.vue?vue&type=template&id=7dd23a9b"
import script from "./StudentOverviewMarkTab.vue?vue&type=script&lang=js"
export * from "./StudentOverviewMarkTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports